import { Component, OnInit, Inject, OnDestroy, forwardRef } from '@angular/core';
import { AppState } from '../../../store/state.model';
import { NgRedux, select } from '@angular-redux/store';
import { Observable } from 'rxjs';
import { AdminState } from '../../../store/admin-store/admin-state.model';
import { UntypedFormGroup, UntypedFormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Email } from './models/email.model';
import { SidenavService } from '../../services/sidenav.service';
import { DatePipe, NgIf, NgFor } from '@angular/common';
import { Phone } from './models/phone.model';
import { SpinnerService } from '../../../common/components/spinner/overlay-spinner.service';
import { SpinnerRef } from '../../../common/components/spinner/overlay-ref.service';
import { AdminApiHandlerService } from '../../services/api-handler/api-handler.service';
import { environment } from '../../../../environments/environment';
import { PhonePipe } from '../../../common/pipes/phone.pipe';
import { AccountSource } from '../../services/create-source';
import { ConfirmationComponent } from '../../confirmation/confirmation.component';
import { MatSnackBar, MatDialog } from '@angular/material';
import { CustomerDispatcher } from '../../../store/customer/customer-dispatcher';
import { StepDispatcher } from '../../../store/steps-store/step-dispatcher';
import { CommonDispatcher } from '../../../store/common/common-dispatcher';
import { VehicleDispatcher } from '../../../store/vehicle-store/vehicle-dispatcher';
import { SelectedVehicleDispatcher } from '../../../store/selected-vehicle-store/selected-vehicle-dispatcher';
import { DialogBoxComponent } from '../../../common/components/dialog-box/dialog-box.component';
import { UpdateDispatcher } from '../../../store/update-customer/update-dispatcher';
import { resetPasswordSteps } from './reset-password/reset-password';
import { OrchestrationService } from '../../services/orchestration-service/orchestration.service';
import { SnackBarService } from '../../../common/services/snack-bar/snack-bar.service';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { ApiResponseDispatcher } from '../../../store/api-response/api-response-dispatcher';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { FinegrainRolesService } from '../../../common/services/finegrain-roles/finegrain-roles.service';
import { MatFormField, MatSuffix, MatError } from '@angular/material/select';
import { MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { MatButton } from '@angular/material/button';
import { TranslatePipe } from '@ngx-translate/core';
const verifyEndPoint = environment.admin.apis.verify_code;

@Component({
    selector: 'app-update-account',
    templateUrl: './update-account.component.html',
    styleUrls: ['./update-account.component.scss'],
    imports: [NgIf, FormsModule, ReactiveFormsModule, MatFormField, MatInput, MatIcon, MatSuffix, MatError, MatButton, NgFor, TranslatePipe]
})
export class UpdateAccountComponent implements OnInit, OnDestroy {
  /**
   * @type {Observable<AdminState>} to observe admin variable
   */
  @select('admin') readonly adminObservable: Observable<AdminState>;
  /**
  *@property model to store the model (Email or Phone)
  **/
  public model: any;
  /**
  *@property customer to store the form of email or phone
  */
  public customer: UntypedFormGroup;
  /**
  *@property isNext stores true when cliked next button
  **/
  public isNext: boolean;
  /**
  *@property title stores translation string for title
  **/
  public title: string;
  /**
  *@property placeholder stores translation string for placeholder of email or phone
  **/
  public placeholder: string;
  /**
  *@property tag stores translation string for tag of email or phone
  **/
  public tag: string;
  /**
  *@property updatedDate stores the formated date Ex: 08/08/2008 08:08 PM (Central Standard Time)
  **/
  public updatedDate: string;
  /**
  *@property activateCodePlaceholder stores the translation string for activate code fields placeholder
  **/
  public activateCodePlaceholder: string;
  /**
  *@property updateDetails stores the adminStore object of email or phone
  **/
  public updateDetails: object;
  /**
  *@property translateParams stores the translateParams object of email or phone
  **/
  public translateParams: object;
  /**
  *@property fieldRequired stores the translation for required field validation error of email or phone and code
  **/
  public fieldRequired: Array<string>;
  /**
  *@property fieldPattern pattern of field
  **/
  public fieldPattern: Array<string>;
  /**
  *@property fieldLength length of field
  **/
  public fieldLength: Array<string>;
  /**
  *@property Reference to the spinner service so it can be open or close in any feature of the screen
  **/
  public spinnerRef: SpinnerRef;
  /**
  *@property to store guid and object params required for updating the address
  **/
  public updateParams: object;
  /**
  *@property to be false if the verification code is Invalid
  **/
  public errorHint: boolean;
  /**
  *@property isAutoVerify to determine auto verify or not
  **/
  public isAutoVerify: boolean;
  /**
  *@property canProceed to determine wheter the entered value is same or not
  **/
  public canProceed: boolean;
  /**
  *@property canForceVerified to determine wheter the entered email eligible for force verification
  **/
  public canForceVerified: boolean;
  /**
   * @property vehicles: list of vehicles associated with the account
   */
  public vehicles: Array<any>;
  /**
   * @property resetPasswordSteps steps to show for reset password
   */
  public resetPasswordSteps: Array<Object>;
  /**
   * @property removeVehicle to store the vehicle to remove from account
   */
  public removeVehicle: object;
  /**
    * @property removeVehicle to store the vehicle to remove from account
    */
  public selectedVehicle: object;
  /**
   * @property to store the subscriptions
   */
  private apiSubscription: Subscription;
  /**
    * @property selectedCountryCode to store the country code of the selected mobile number
    */
  public selectedCountryCode: string;
  /**
    * @property isVehicleRetry to store the flag for vehicle retry
    */
  public isVehicleRetry: boolean;
  /**
* @property unlinkAllResponses to store all the unlinkvehicles responses
*/
  public unlinkAllResponses: Array<object>;
  /**
  * @property isUnlinkAllFailed to store the flag for unlink all vehicles 
  */
  public isUnlinkAllFailed: boolean;
  /**
  * @property vehicleAssociationActiveGuid to store the GUID for vehicle association (required for non-CVT vehicles)
  */
  public vehicleAssociationActiveGuid: string;
  constructor(
    @Inject(forwardRef(() => AdminApiHandlerService)) public apiHandler: AdminApiHandlerService,
    public fb: UntypedFormBuilder,
    private sidenav: SidenavService,
    public datePipe: DatePipe,
    public spinner: SpinnerService,
    public ngRedux: NgRedux<AppState>,
    public phonePipe: PhonePipe,
    public customer_dispatcher: CustomerDispatcher,
    private readonly snackBar: MatSnackBar,
    public stepDispatcher: StepDispatcher,
    public commonDispatcher: CommonDispatcher,
    public updateState: UpdateDispatcher,
    public dialog: MatDialog,
    private orchestrationService: OrchestrationService,
    private snackBarService: SnackBarService,
    private translate: TranslationService,
    public apiDispatcher: ApiResponseDispatcher,
    private router: Router,
    public finegrainRolesService: FinegrainRolesService,
    private vehicleDispatcher: VehicleDispatcher,
    private selectedVehicleDispatcher: SelectedVehicleDispatcher,
  ) {
  }
  /**
   * @function ngOnInit Method to Initializes the component and perform initial operations
   */
  ngOnInit(): void {
    this.apiSubscription = this.adminObservable.subscribe((adminStore) => {
      this.updateDetails = adminStore;
      const updateAttribute = this.updateDetails['updateAttribute'];
      const updateValue = this.updateDetails['updateValue'];
      this.getUpdateType(updateAttribute);

      this.customer = this.model && this.model.form && this.fb.group(this.model.form);
      this.selectedVehicle = this.ngRedux.getState().selectedVehicle.vehicle;
      if (this.ngRedux.getState().customer['data']['phoneNumbers']) {
        this.selectedCountryCode = this.ngRedux.getState().customer['data']['phoneNumbers'][0].countryCode === 1 ? '+1' : '+52';
      }
      if (this.customer) {
        this.customer.setValue({
          editValue: !!this.updateDetails && !!updateValue ? updateValue : this.model.values.editValue,
          activationCode: this.model.values.activationCode
        });
      }

      if (this.model) {
        this.tag = this.model.tag;
        this.placeholder = this.model.placeholder;
        this.translateParams = this.model.translateParams;
        this.fieldRequired = this.model.fieldRequired;
        this.fieldPattern = this.model.fieldPattern;
        this.fieldLength = this.model.fieldLength;
        this.updatedDate = AccountSource.getDate(this.updateDetails['updatedDate']);
        this.validate();
      }
    });
    this.isNext = true;
    this.errorHint = false;
    this.title = 'update-account.labels.title';
    this.activateCodePlaceholder = 'update-account.labels.activation-code-placeholder';
    this.isVehicleRetry = false;
    this.isUnlinkAllFailed = false;
  }
  /**
   * on destroy method
   */
  ngOnDestroy() {
    this.apiSubscription?.unsubscribe();
  }
  /**
   * @function getUpdateType verifies the update type and sets variables
   */
  private getUpdateType(updateAttribute: string): void {
    switch (updateAttribute) {
      case 'email':
        this.model = new Email({ editValue: this.updateDetails['updateValue'], activationCode: '' });
        break;
      case 'phone':
        this.model = new Phone({ editValue: this.updateDetails['updateValue'], activationCode: '' });
        break;
      case 'delete':
        this.vehicles = this.ngRedux.getState().vehicle.vehicles['vehicles'];
        break;
      case 'remove-vehicle':
        const { customer, vehicle, vehicleAssociationActiveGuid } = this.updateDetails['updateValue'];
        this.vehicles = this.ngRedux.getState().vehicle.vehicles['vehicles'];
        this.removeVehicle = vehicle;
        this.customer = customer;
        this.vehicleAssociationActiveGuid = vehicleAssociationActiveGuid || '';
        break;
      case 'reset-password':
        this.resetPasswordSteps = resetPasswordSteps;
        this.scrollToTop();
        break;
    }
  }
  /**
   * @method scrollToTop scrolls page to top from html call
   * @returns void
   */
  public scrollToTop(): void {
    window.scroll(0, 0);
  }
  /**
   * @method onKeyUp updates the form value
   * @returns void
   **/
  public onKeyUp(): void {
    this.customer.controls.editValue.setValue(this.customer.controls.editValue.value.replace(/ /g, '').trim());
    this.customer.controls.editValue.updateValueAndValidity();
    this.validate();
  }
  /**
   * @method validate will determain whether the entered value is same or not
   * @returns void
   **/
  public validate(): void {
    const { customer: { data } } = this.ngRedux.getState();
    const isVerified = this.updateDetails['updateAttribute'] === 'email' ?
      (data['emails'][0]['emailVerified'] ? true : false) : (!!data['phoneNumbers'] ? (`${data['phoneNumbers'][0]['phoneVerified']}` === 'true' ? true : false) : false);
    const updatedValue = this.customer.controls.editValue.value;
    this.canForceVerified = this.model.values.editValue === updatedValue;
    this.canProceed = this.canForceVerified && isVerified ? false : true;
  }
  /**
   * @method resetKey resets error flag to false
   * @returns void
   **/
  public resetKey(): void {
    this.errorHint = false;
  }
  /**
  * @function storeUpdateParams store customer update api call params guid and object id
  * @param {object} response  Response of the API
  **/
  public storeUpdateParams(): void {
    const customer = this.ngRedux.getState().customer.data;
    this.updateParams = { guid: customer['guid'], objectId: customer['objectId'] };
  }
  /**
  * @function updateCustomer api call to update the address
  **/
  public updateCustomer(): void {
    this.storeUpdateParams();
    const guid = this.updateParams['guid'];
    this.getvehicleList(guid);
  }
  /**
 * @function getvehicleList prepares a vin list
 */
  private getvehicleList(guid) {
    let generation = '17CYPLUS';
    let vehiclebrands = '';
    const spinnerRef = this.spinner.open();
    this.apiHandler.getRequest(environment.admin.apis.subscription.vehicleAssociation, {
      type: 'vehicle_list', params: {
        guid: guid
      }
    }).subscribe({
      next: (res) => {
        spinnerRef.close();
        if (res.payload && res.payload.length > 0) {
          const brand: Array<any> = res.payload.map(vehicle => vehicle.brand);
          const vehicleGeneration: Array<any> = res.payload.map(vehicle => vehicle.generation);
          generation = vehicleGeneration.includes('PRE17CY') ? 'PRE17CY' : vehicleGeneration.includes('17CY') ? '17CY' : '17CYPLUS';
          vehiclebrands = brand.includes('T') ? vehiclebrands + 'T' : vehiclebrands;
          vehiclebrands = brand.includes('L') ? vehiclebrands + 'L' : vehiclebrands;
          vehiclebrands = brand.includes('S') ? vehiclebrands + 'S' : vehiclebrands;
        }
        this.updateAccount(vehiclebrands, generation);
      },
      error: () => {
        this.updateAccount(vehiclebrands, generation);
        spinnerRef.close();
      }
    });
  }
  /**
    * @function updateAccount update account api call
    **/
  updateAccount(vehiclebrands, generation) {
    this.spinnerRef = this.spinner.open();
    const updateValue = this.updateDetails['updateAttribute'] === 'phone' ? this.customer.controls.editValue.value.replace(/\D/g, '') : this.customer.controls.editValue.value;

    this.apiHandler.putRequest(this.canForceVerified ? environment.admin.apis.customer_update : this.model.endPoint,
      { customer: Object.assign({ userID: this.ngRedux.getState().auth.email }, this.updateParams, this.model.payload(updateValue, 'update', '', this.selectedCountryCode ? this.selectedCountryCode.replace('+', '') : '')) },
      {
        type: 'acm-cu', params: {
          generation: generation,
          vehiclebrands: vehiclebrands
        }
      }).subscribe({
      next: (response) => this.successCallback(response),
      error: (error) => {
          this.spinnerRef.close();
          this.errorCallback(error);
        }
    }
      );
  }
  /**
  * @function sendCode will send the code to verify the address
  **/
  public sendCode(requestCode?: boolean): void {
    this.storeUpdateParams();
    this.spinnerRef = this.spinner.open();
    const updateValue = this.updateDetails['updateAttribute'] === 'phone' ? this.customer.controls.editValue.value.replace(/\D/g, '') : this.customer.controls.editValue.value;
    this.apiHandler.postRequest(verifyEndPoint, Object.assign({}, { guid: this.updateParams['guid'] }, { countryCode: this.selectedCountryCode }, this.model.payload(updateValue, 'verify', requestCode)),
      { type: 'acm', params: { brand: this.selectedVehicle && this.selectedVehicle['brand'] || 'T' } }).subscribe({
      next: (response) => this.sendCodesuccessCallback(response),
      error: (error) => {
          this.spinnerRef.close();
          this.errorCallback(error);
        }
    }
      );
  }
  /**
   * @function verifyCode api call to verify the code
   **/
  public verifyCode(): void {
    const updateValue = this.updateDetails['updateAttribute'] === 'phone' ? this.customer.controls.editValue.value.replace(/\D/g, '') : this.customer.controls.editValue.value;
    this.storeUpdateParams();
    this.spinnerRef = this.spinner.open();
    this.apiHandler.patchRequest(verifyEndPoint, Object.assign({}, { guid: this.updateParams['guid'] },
      this.model.payload(updateValue, 'verify'), { verificationCode: this.customer.controls.activationCode.value }), { type: 'acm', params: { brand: this.selectedVehicle && this.selectedVehicle['brand'] || 'T' } }).subscribe({
      next: (response) => this.verifyCodesuccessCallback(response),
      error: (error) => {
          this.spinnerRef.close();
          this.errorCallback(error)
        }
    }
      );
  }
  /**
  * @function successCallback Action after a successful API response
  * @Param {object} response  Response of the API
  **/
  public successCallback(response: any): void {
    this.spinnerRef.close();
    this.confirmation(this.updateDetails['updateAttribute'] === 'email' ? 'email-update' : 'phone-update', true);
    this.customer_dispatcher.setCustomerData(response.payload.customer);
    this.updateState.setUpdateInfo('true');
  }
  /**
   * @function sendCodesuccessCallback will be called after sendCode call was successful
   * @Param {object} response of the API
   **/
  public sendCodesuccessCallback(response: any): void {
    this.spinnerRef.close();
  }
  /**
   * @function verifyCodesuccessCallback will be called after verifyCode call was successful
   * @Param {object} response  Response of the API
   **/
  public verifyCodesuccessCallback(response: any): void {
    this.spinnerRef.close();
    this.updateCustomer();
    this.isNext = true;
    this.sidenav.toggle();
  }
  /**
  * @function errorCallback Action for error after API response
  * @param {object} error  Response of the API
  **/
  public errorCallback(error: object): void {
    // Ensure spinner is closed on error
    if (this.spinnerRef) {
      this.spinnerRef.close();
    }
    error['errorCode'] === 'AVCD-0006' ? this.errorHint = true : error['errorCode'] === 'SUB-0015' ? this.confirmation('unable-to-update', false) :
      this.dialog.open(DialogBoxComponent, {
        data: {
          type: 'api-error',
          message: error['errorMessage'],
          endPoint: error['api']
        },
        width: '30em',
        height: 'auto'
      });
  }
  /**
  * @function save will verify the email or phone when entered the code
  **/
  public save(): void {
    this.verifyCode();
  }
  /**
  * @function next will update the customer details and sent a verification code to the respected contact address mentioned such as email or phone
  **/
  public next(): void {
    this.isNext = false;
    this.customer.get('editValue').disable();
    this.customer.markAsUntouched();
    this.sendCode(false);
  }
  /**
  * @function cancel will set the isNext to true, errorhint to false and disables the input field
  **/
  public cancel(): void {
    this.isNext = true;
    this.errorHint = false;
    this.customer.get('editValue').enable();
  }
  /**
  * @function back will set the isNext to true and closes the side nav when called
  **/
  public back(): void {
    this.isNext = true;
    this.sidenav.toggle();
  }
  /**
  * @function confirmation should call confirmation component when called
  * @param updateValue of type string
  **/
  public confirmation(updateValue: string, success: boolean): void {
    window.scrollTo(0, 0);
    this.snackBar.openFromComponent(ConfirmationComponent, {
      data: {
        type: updateValue,
        success
      },
      verticalPosition: 'top',
      panelClass: ['admin-confirmation'],
    });
  }
  /**
  * @function force force verifies the email or phone
  **/
  public force(): void {
    this.updateCustomer();
    this.isNext = true;
    this.sidenav.toggle();
  }
  /**
   * @function verifyValue verifies if the value was changed
   */
  public verifyValue(): boolean {
    return this.customer.controls.editValue.value === this.updateDetails['updateValue'];
  }
  /**
   * @function deleteAccount delete the account
   */
  public deleteAccount(): void {
    this.storeUpdateParams();
    this.spinnerRef = this.spinner.open();
    const params = {
      guid: this.updateDetails['updateValue']['data']['guid']
    };

    this.orchestrationService.deleteAccount(params).subscribe({
      next: (response) => {
        this.spinnerRef.close();
        this.snackBarService.showToast(this.translate.getCustomTranslation('update-account.labels.deleted-vehicle')['value']);
        this.customer_dispatcher.setCustomerData({});
        this.customer_dispatcher.customerFound(false);
        this.customer_dispatcher.customerNotFoundError(false);
        this.customer_dispatcher.setCustomerDetails('', '', '', '');
        this.vehicleDispatcher.resetVehicleStore();
        this.selectedVehicleDispatcher.resetSelectedVehicleStore();
        this.stepDispatcher.isVehicleAssociated({
          isVehicleAssociated: false,
          vehicleAssociatedGuid: ''
        });
        this.sidenav.toggle();
        this.router.navigate(['/dashboard/admin']);
      },
      error: (error) => {
        this.spinnerRef.close();
        this.errorCallback(error);
      }
    }
    );
  }
  /**
* @function errorDialog Action for error after unlink all API response
* @param {object} response  Response of the APIs
**/
  public errorDialog(response: object): void {
    this.spinnerRef.close();
    this.dialog.open(DialogBoxComponent, {
      data: {
        type: 'unlink-all',
        message: response,
        endPoint: 'unlink api'
      },
      width: '30em',
      height: 'auto'
    });
  }
  /**
   * @function unlinkAll unlinks all the associated vehicles from the account
   */
  public unlinkAll(vehicles) {
    this.spinnerRef = this.spinner.open();
    this.unlinkAllResponses = [];
    const unlinkingAllVehicles = vehicles.map(vehicle => {
      this.unlinkVehicle(vehicle, true, vehicles);
    });
  }
  /**
     * @function unlinkVehicle unlinks the vehicle from the account
     */
  public unlinkVehicle(vehicleData: Object, isUnlinkAll?: boolean, allVehicles?: any): void {
    this.storeUpdateParams();
    const { data } = this.ngRedux.getState().customer;
    if (!isUnlinkAll) { this.spinnerRef = this.spinner.open(); }
    let generation = vehicleData['generation'];
    if (!generation && this.vehicles) {
      const matchingVehicle = this.vehicles.find(v => v.vin === vehicleData['vin']);
      if (matchingVehicle && matchingVehicle.generation) {
        generation = matchingVehicle.generation;
      }
    }
    
    // Map PRE17CY to 17CY for backend compatibility
    // Backend only accepts: 17CY, 17CYPLUS, GR86, 21MM, 24MM
    if (generation === 'PRE17CY') {
      generation = '17CY';
    }
    
    let body: any = {
      vin: vehicleData['vin'],
      status: 'SOLD',
      userID: this.ngRedux.getState().auth.email
    };
    if (generation) {
      body['generation'] = generation;
    }
    
    // Add guid - use vehicle's subscriberGuid or fallback to customer GUID for non-CVT vehicles
    // Backend expects 'guid' field in body, not 'subscriberGuid'
    if (vehicleData['subscriberGuid']) {
      body['guid'] = vehicleData['subscriberGuid'];
    } else if (vehicleData['nonCvtVehicle']) {
      // For non-CVT vehicles without subscriberGuid, use customer GUID
      const customerGuid = data && data['guid'] ? data['guid'] : null;
      body['guid'] = customerGuid;
    }
    
    const brand = vehicleData['brand'] 
      ? vehicleData['brand'] 
      : (vehicleData['brandCode'] && ['TOY', 'T', 'TOYOTA'].indexOf(String(vehicleData['brandCode']).toUpperCase()) > -1) 
        ? 'T' 
        : (vehicleData['brandCode'] && ['SUB', 'S', 'SUBARU'].indexOf(String(vehicleData['brandCode']).toUpperCase()) > -1) 
          ? 'S' 
          : 'L';
    const params: any = { ...body, brand: brand };

    this.orchestrationService.unlinkVehicle(body, params).subscribe({
      next: (response) => {
        this.spinnerRef.close();
        this.customer_dispatcher.setCustomerData({});
        this.customer_dispatcher.customerFound(false);
        this.customer_dispatcher.customerNotFoundError(false);
        this.stepDispatcher.isVehicleAssociated({
          isVehicleAssociated: false,
          vehicleAssociatedGuid: ''
        });
        this.stepDispatcher.storeGuidValue(null);
        const currentVehicle = this.ngRedux.getState().selectedVehicle.vehicle;
        if (currentVehicle && currentVehicle['vin'] === vehicleData['vin']) {
          this.selectedVehicleDispatcher.setSelectedVehicle({ ...currentVehicle, subscriberGuid: null });
        }
        this.vehicles = this.vehicles.filter(vehicle => vehicle['vin'] !== vehicleData['vin']);
        this.apiDispatcher.setVinlistResponse(Object.assign({ payload: this.vehicles }, { type: 'success' }));
        if (this.updateDetails['updateAttribute'] === 'remove-vehicle') {
          this.sidenav.close();
        }
        if (!isUnlinkAll) {
          this.snackBarService.showToast(this.translate.getCustomTranslation('update-account.labels.unlinked-vehicle')['value']);
          this.spinnerRef.close();
        }
        this.orchestrationService.getVehicleByVin({ vin: params['vin'] });
        if (isUnlinkAll) {
          this.unlinkAllResponses.push({ 'vin': vehicleData['vin'], 'type': 'Unlink Successful', 'response': '' });
          if (this.unlinkAllResponses.length === allVehicles.length) {
            if (this.isUnlinkAllFailed) {
              this.errorDialog(this.unlinkAllResponses);
            }
            this.spinnerRef.close();
          }
        }
      },
      error: (error) => {
        if (isUnlinkAll) {
          this.isUnlinkAllFailed = true;
          const friendlyErrorMessage = this.parseUnlinkError(error, vehicleData);
          this.unlinkAllResponses.push({ 'vin': vehicleData['vin'], 'type': 'Unlink Failed', 'response': friendlyErrorMessage });
          if (this.unlinkAllResponses.length === allVehicles.length && this.isUnlinkAllFailed) {
            this.errorDialog(this.unlinkAllResponses);
          }
        } else {
          if (error.errorCode === 'ORCH-6003' && this.finegrainRolesService.getCustomerPermissions('retryVehicle')) {
            this.retryUnlink(isUnlinkAll);
          } else {
            const friendlyError = this.parseUnlinkError(error, vehicleData);
            if (friendlyError !== error['errorMessage']) {
              // Show custom error dialog with parsed missing parameters
              this.dialog.open(DialogBoxComponent, {
                data: {
                  type: 'api-error',
                  message: friendlyError,
                  endPoint: error['api']
                },
                width: '30em',
                height: 'auto'
              });
            } else {
              this.errorCallback(error);
            }
          }
        }
        this.spinnerRef.close();
      }
    }
    );
  }
  /**
   * @function parseUnlinkError Parse unlink vehicle error to identify missing parameters
   * @param {object} error API error response
   * @param {object} vehicleData Vehicle data being unlinked
   * @returns {string} User-friendly error message
   */
  private parseUnlinkError(error: object, vehicleData: object): string {
    const errorMessage = error['errorMessage'] || '';
    const errorCode = error['errorCode'] || '';
    if (errorMessage.toLowerCase().includes('internal server error') || 
        errorCode === '500' || 
        errorMessage.toLowerCase().includes('required') ||
        errorMessage.toLowerCase().includes('missing')) {
      const missingParams = [];
      let generation = vehicleData['generation'];
      if (!generation && this.vehicles) {
        const matchingVehicle = this.vehicles.find(v => v.vin === vehicleData['vin']);
        if (matchingVehicle && matchingVehicle.generation) {
          generation = matchingVehicle.generation;
        }
      }
      
      const sentBody: any = {
        vin: vehicleData['vin'],
        status: 'SOLD',
        userID: this.ngRedux.getState().auth.email
      };
      
      if (generation) {
        sentBody['generation'] = generation;
      }
      
      if (vehicleData['nonCvtVehicle'] && !vehicleData['subscriberGuid']) {
        if (this.vehicleAssociationActiveGuid) {
          sentBody['guid'] = this.vehicleAssociationActiveGuid;
        } else {
          const { data } = this.ngRedux.getState().customer;
          sentBody['guid'] = this.updateParams['guid'] || data['guid'];
        }
      } else if (vehicleData['subscriberGuid']) {
        sentBody['guid'] = vehicleData['subscriberGuid'];
      }
      
      if (!sentBody.vin || sentBody.vin === '') {
        missingParams.push('VIN');
      }
      if (!sentBody.status || sentBody.status === '') {
        missingParams.push('Status');
      }
      if (!sentBody.generation || sentBody.generation === '') {
        missingParams.push('Generation');
      }
      if (vehicleData['nonCvtVehicle'] && (!sentBody.guid || sentBody.guid === '')) {
        missingParams.push('GUID');
      }
      if (missingParams.length > 0) {
        return `Unable to unlink vehicle. Missing required parameter(s): ${missingParams.join(', ')}. Please ensure all required information is available before unlinking.`;
      }
    }
    return errorMessage;
  }
  /**
* @function retryUnlink enable retry vehicle option
**/
  public retryUnlink(isUnlinkAll): void {
    this.isVehicleRetry = true;
    if (!isUnlinkAll) { this.spinnerRef.close(); }
  }
  /**
 * @function getUnlinkMessage Gets the correct message if the subscription has paid services
 */
  public getUnlinkMessage(vehicleData: object): string {
    const subscriptions = vehicleData['subscriptions'];
    const paidServices = !!subscriptions ? subscriptions.filter(sub => sub.type.toLowerCase() === 'paid') : [];
    return paidServices.length > 0 ? 'remove-vehicle.labels.remove-paid-vehicle-message' : this.isVehicleRetry ? 'remove-vehicle.labels.retry-unlink' : 'remove-vehicle.labels.remove-trial-vehicle-message';
  }
}
